
import React, { Component } from 'react';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';
import APIService from '../Services/APIService/apiService';
import { Button } from 'reactstrap';
import {  Redirect } from 'react-router-dom';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class Report extends Component{

    constructor(props){
        super(props);
        this.state = {
            APIName: "reportsEmail",
            EmailTo: "",
            SerializedSettings: "",
            loadingReport: false,
            type: 'password',
            isAutenticated: true
        };
        this.handleEmailTo = this.handleEmailTo.bind(this);
        this.handleSerializedSettings = this.handleSerializedSettings.bind(this);
    }  

    componentDidMount(){

        var ReportmList = this.props.DataReport;

        var Report = ReportmList.find(x=> x.ALIAS === this.state.APIName);  
        var ReportValue = JSON.parse(Report.VALUE);
        var EmailTo = ReportValue.EmailTo === null || ReportValue.EmailTo === undefined   ? "" :  ReportValue.EmailTo;
        var SerializedSettings = ReportValue.SerializedSettings === null || ReportValue.SerializedSettings === undefined   ? "" :  ReportValue.SerializedSettings;

        let stateCopy = Object.assign({}, this.state);
        stateCopy.EmailTo = EmailTo;
        stateCopy.SerializedSettings = SerializedSettings;
        this.setState(stateCopy);
    }

    handleEmailTo(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.EmailTo = value;
        this.setState(stateCopy);    
    }
    handleSerializedSettings(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.SerializedSettings = value;
        this.setState(stateCopy);    
    }

    ValidateSaveReport(){

        var EmailTo = this.state.EmailTo;

        if(EmailTo === null || EmailTo === "" || EmailTo === undefined)
        {
            toast.error("EmailTo field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }       
        return true;
    }

    SaveReport(e){
        e.preventDefault();    
        var email = sessionStorage.getItem('email');
        var that = this;
        var EmailTo = this.state.EmailTo;
        var SerializedSettings = this.state.SerializedSettings;
        var CompanyCode = this.props.CompanyCode;

        var ReportList = this.props.DataReport;
        var Report = ReportList.find(x=> x.ALIAS === this.state.APIName);   

        var Validate = this.ValidateSaveReport();
        if(Validate === false)
        {
            return false;
        }
        
        this.setState({
            loadingReport: true
        });

        var result = APIService.SaveReportSetting(CompanyCode, email, EmailTo, SerializedSettings);

        result.then(function(data){
            if(data.data === "OK"){
                that.setState({
                    loadingReport: false
                });
                var newList = {
                    ALIAS: Report.ALIAS,
                    COMPANY_CODE: CompanyCode,
                    ID: Report.ID,
                    NAME: Report.NAME,
                    VALUE: {
                        EmailTo: EmailTo,
                        SerializedSettings: SerializedSettings,
                        Name:Report.ALIAS
                    }
                };
                that.props.SetObject(newList);
                toast.success("Saved!", { className: {
                    opacity: 0.8
                }});            
            }else if(data.data === "NoExist"){
                that.setState({
                    loadingReport: false
                });  
                toast.error("API Setting dosen't exist!", { className: {
                    opacity: 0.8
                }});
            }else if(data.data === "Empty"){
                that.setState({
                    loadingReport: false
                });                
                toast.error("Not Exist!", { className: {
                    opacity: 0.8
                }});
            }
        }).catch((error) => {

            that.setState({
                loadingReport: false,
            });      
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });        
    }   
    render(){   
        
        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }
        
        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar/>
                    <div className="card-body" style={{ height: "600px", 'overflowY': 'scroll'}}>
                        <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Name</label>
                            </div>   
                            <div className="col-2">
                                    <input style={{ 'marginTop': '10px' }} className="form-control" name="name" id="name" type="text" value={ this.state.APIName} readOnly/>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Emails To(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-8" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="EmailTo" id="EmailTo" type="text" onChange={this.handleEmailTo}  value={ this.state.EmailTo}/>
                            </div>                         
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Settings</label>
                            </div>   
                            <div className="col-8" style={{ marginRight: "100px" }}>
                                <textarea  style={{ 'marginTop': '10px'}} className="form-control" name="SerializedSettings" id="SerializedSettings" rows="5" type="text" onChange={this.handleSerializedSettings } value={ this.state.SerializedSettings}></textarea>
                            </div>                           
                       </div>
                       <div className="row">             
                            <div className="col-2 offset-10" style={{ 'paddingTop': '190px'}} size="sm">
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#33B5E5'}
                                    loading={this.state.loadingReport}
                                />
                                {
                                    this.state.loadingReport
                                    ?
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveReport(e)} disabled>Save</Button>
                                    : 
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveReport(e)}>Save</Button>
                                }
                               
                            </div>                             
                       </div>
                   </div>
                </div>
            </div>            
        );
    }
}

export default Report;


// WEBPACK FOOTER //
// ./src/APIComponent/Report.jsx